var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOutlineZipFiles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 3H19V8V21H5V3Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 3V10",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7402 18H7.40332V17.2852L9.25781 14.6514H7.44727V13.7168H10.6934V14.4287L8.83887 17.0654H10.7402V18ZM11.3555 18V13.7168H12.5186V18H11.3555ZM14.9297 13.7168C15.4727 13.7168 15.8789 13.835 16.1484 14.0713C16.4199 14.3076 16.5557 14.6436 16.5557 15.0791C16.5557 15.2744 16.5273 15.4619 16.4707 15.6416C16.416 15.8213 16.3252 15.9814 16.1982 16.1221C16.0732 16.2627 15.9062 16.374 15.6973 16.4561C15.4902 16.5381 15.2344 16.5791 14.9297 16.5791H14.6045V18H13.4473V13.7168H14.9297ZM14.9033 14.6514H14.6045V15.6357H14.833C14.9326 15.6357 15.0254 15.6191 15.1113 15.5859C15.1973 15.5508 15.2656 15.4951 15.3164 15.4189C15.3691 15.3408 15.3955 15.2373 15.3955 15.1084C15.3955 14.9736 15.3555 14.8643 15.2754 14.7803C15.1953 14.6943 15.0713 14.6514 14.9033 14.6514Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineZipFiles);
export default __webpack_public_path__ + "static/media/outline-zip-files.c92349ac.svg";
export { ForwardRef as ReactComponent };